import { StorageService } from './../../../services/storage/storage.service';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
import { Component, OnInit } from '@angular/core';
import { CredentialsService } from 'src/app/services/credentials/credentials.service';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { RouterService } from 'src/app/services/router/router.service';
import { UtilsService } from '../../../services/utils/utils.service';
import { TagsService } from 'src/app/services/tags/tags.service';
import { AlertService } from 'src/app/services/alert/alert.service';
import { RedemptionService } from 'src/app/services/redemption/redemption.service';
import { ModalController } from '@ionic/angular';
import {
  CATALOGUE_HAS_PUBLIC_SERVICES,
  HasExternalPays,
} from './config-external-pays';
import { CanExchangeService } from 'src/app/services/can-exchange/can-exchange.service';
import { CanExChange } from 'src/app/interfaces/ICanExchange';

@Component({
  selector: 'app-catalogue',
  templateUrl: './catalogue.page.html',
  styleUrls: ['./catalogue.page.scss'],
})
export class CataloguePage implements OnInit {
  public BottomSheetState = 'close';
  externalFilters = {};
  points: any;
  pointsAbbreviation: string = ' coins';
  valueClearInput: boolean = false;
  redemptionLimit = false;
  isRedemptionActive = false;
  canExchange: any;
  CATALOGUE_HAS_PUBLIC_SERVICES = CATALOGUE_HAS_PUBLIC_SERVICES;
  constructor(
    private credentialsService: CredentialsService,
    private routerService: RouterService,
    public languageService: LanguagesService,
    private utilsService: UtilsService,
    private tagsService: TagsService,
    public alertService: AlertService,
    private redemptionService: RedemptionService,
    private modalController: ModalController,
    private remoteConfig: RemoteConfigService,
    private canExchangeService: CanExchangeService,
    private storageService: StorageService
  ) {}

  async ngOnInit() {
    const { programs } = await this.storageService.get('gnx-claims');

    if (programs[0].split('/').at(-1) == 'estrellas_colombia') {
      this.remoteConfig
        .getSettingConfigExternalPay()
        .subscribe((data: HasExternalPays) => {
          console.log('getSettingConfigExternalPay', data);
          this.CATALOGUE_HAS_PUBLIC_SERVICES = Object.entries(data).toString()
            .length
            ? { ...CATALOGUE_HAS_PUBLIC_SERVICES, ...data }
            : { ...CATALOGUE_HAS_PUBLIC_SERVICES };
        });
    }

    this.canExchanges();
    this.tagsService.setEventTag('rewards_page', 'rewards_screen_viewed');
    this.utilsService.getUserPoints().then((result: any) => {
      this.points = result;
    });
    this.listensetTagCategory();
    this.checkRedemption();
    this.modalController.dismiss();
  }

  listensetTagCategory() {
    document.addEventListener('catalogueCategories', (res) => {
      this.tagsService.setEventTag('rewards_page', 'rewards_category_clicked');
      const result: any = res;
      const evento: CustomEvent<any> = result;
      console.debug(evento.detail);
      if (Object.keys(evento.detail).includes('id')) {
        const idPublicAutomatic = this.CATALOGUE_HAS_PUBLIC_SERVICES
          .PublicServicesAutomaticCategory?.idCategory
          ? this.CATALOGUE_HAS_PUBLIC_SERVICES?.PublicServicesAutomaticCategory
              ?.idCategory
          : 'paymentServicesAutomatic';
        const idOtherPays = this.CATALOGUE_HAS_PUBLIC_SERVICES
          .PublicServicesCategory?.idCategory
          ? this.CATALOGUE_HAS_PUBLIC_SERVICES?.PublicServicesCategory
              ?.idCategory
          : 'paymentServices';

        if (evento.detail.id === idPublicAutomatic) {
          this.routerService.redirect(`app/pay-services-automatic`);
        } else if (evento.detail.id === idOtherPays) {
          this.routerService.redirect(`app/payment-terminal`);
        }

        const handlerClear = document.getElementById('handleClearFilters');
        if (handlerClear) handlerClear.click();
      }
    });
  }

  async checkRedemption() {
    const programInfo = await this.redemptionService.getProgramInfo();
    this.redemptionLimit = programInfo['redemption_limit']?.enabled
      ? true
      : false;
    this.isRedemptionActive = await this.redemptionService.validateRedemption();
  }

  async ionViewDidEnter() {
    console.log('ionViewDidEnter CataloguePage');

    if (!this.isRedemptionActive) {
      await this.redemptionService.checkRedemption();
    }
    this.canExchanges();
  }

  clearInput(event) {
    this.valueClearInput = event.detail;
  }

  productSelected(product) {
    const productId = product.detail.id.raw;
    if (product.detail.sku.raw == 'PaymentServicesSKU') {
      this.routerService.redirect(`app/payment-services`);
    } else if (product.detail.sku.raw == 'cardTerminalSKU') {
      this.routerService.redirect(`app/payment-terminal`);
    } else {
      this.routerService.redirect(`app/catalogue/${productId}`);
    }
  }
  credentialsCatalogue = () => {
    return this.credentialsService.catalogueNew();
  };

  public StateChanged(event) {
    this.BottomSheetState = event;
  }
  handleModal = (event) => {
    this.BottomSheetState = event.detail;
    this.tagsService.setEventTag(
      'rewards_page',
      'rewards_filter_clicked',
      false,
      true
    );
  };

  handleExternalFilters = (event) => {
    this.tagsService.setEventTag(
      'rewards_page',
      'rewards_filter_apply',
      false,
      true
    );
    this.externalFilters = event.detail;
  };
  get getTextIUCatalogue() {
    return this.languageService.textsIU.page_catalogue;
  }

  get getTextIUCurrency() {
    return this.languageService.textsIU.currency_data;
  }

  async canExchanges() {
    this.canExchange = await this.canExchangeService.getCanExchange();
    this.canExchange = this.canExchange.code;

    if (this.canExchange === CanExChange.EXCHANGE_DISABLED_BY_PADLOCK) {
      return this.canExchangeService.openModal('exchange');
    }
  }
}
